(() => {
  // Shopify's banner can link to the shop domain while the theme is previewed locally.
  if (!['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)) return;

  const policyUrl = document.currentScript?.dataset.policyUrl;
  if (!policyUrl) return;

  let policyPath;
  try {
    const url = new URL(policyUrl, window.location.origin);
    if (!/\/policies\/privacy-policy\/?$/.test(url.pathname)) return;
    policyPath = `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return;
  }

  function updateLink() {
    const link = document.getElementById('shopify-pc__banner__body-policy-link');
    if (!link) return;
    if (link.getAttribute('href') !== policyPath) link.setAttribute('href', policyPath);
    if (link.hasAttribute('target')) link.removeAttribute('target');
  }

  updateLink();
  const observer = new MutationObserver(updateLink);
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['id', 'href', 'target'] });
})();
